/**
 * Route paths for the objectives pages. Dependency-free on purpose: App.tsx needs
 * these at startup, and objectiveConstants.tsx (which re-exports them) pulls in
 * validation utilities that would otherwise land in the eager bundle.
 */
export const OBJECTIVE_LIST_PATH = "/objectives";

export const objectiveDetailPath = (uuid: string): string => `${OBJECTIVE_LIST_PATH}/${uuid}`;
